<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 08:55:49
 * @LastEditTime : 2020-01-21 09:55:15
 * @LastEditors  : Please set LastEditors
 -->
<template>
  <div
    class="city-box"
    :class="{'city-box-hidden':!isPopupShow}"
  >
    <div class="city-box-inner">
      <!--<div class="city_close" @click="closePopu()">X</div>-->

      <div class="def_city_con">
        <div><span>当前行政区划：</span> 
        <span style="font-size: 13px;">{{curCity}}</span></div>
      </div>
      

      <div class="hot_city">

        <span style="font-weight: 700;cursor:pointer;padding-right: 5px;"
          @click="_cityClickHandler(province.name, province.code)"
        >{{province.name}}</span>

        <a
          href="javascript:;"
          v-for="(item, index) in hotCityData"
          :key="index"
          @click="_cityClickHandler(item.name, item.code)"
        >{{item.name}}</a>
      </div>

      <div>
        <div class="ps_container">
          <div class="city_list_province">
            <div
              class="city_list_province_line clearfix"
              v-for="(item, index) in xzqData['62']"
              :key="index"
            >
              <div
                class="city_list_province_header city_list_provin"
                @click="_cityClickHandler(item.name, item.code)"
              >{{item.name}}</div>
              <div class="city_list_province_right">
                <a
                  href="javascript:;"
                  v-for="(item1, index1) in xzqData[item.code]"
                  :key="index1"
                  @click="_cityClickHandler(item1.name, item1.code)"
                >{{item1.name}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { UCDistrictData, UCDistictEvent, CityInfo } from "./UCDistrictJs.js";

export default {
  name: "UCDistrictCity",
  data() {
    return {
      isPopupShow: false,
      province:{},
      hotCityData: [],
      xzqData: [],
      locationData: [],
      curCity: "全省"
    };
  },
  props: {
    widgetActiveFlag: {
      default: function() {
        return false;
      }
    },
    olMap: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    widgetActiveFlag: {
      handler: function(val, val2) {
        this.isPopupShow = val;
      },
      deep: true
    }
  },
  components: {},
  methods: {
    openPopu() {
      this.isPopupShow = true;
    },

    closePopu() {
      this.isPopupShow = false;
    },

    off_cityClick(callback) {
      if (callback) {
        this.$off(
          UCDistictEvent.UCDistrictCity_event_cityClickHandler,
          callback
        );
      }
    },

    on_cityClick(callback) {
      if (callback) {
        this.$on(
          UCDistictEvent.UCDistrictCity_event_cityClickHandler,
          callback
        );
      }
    },

    _cityClickHandler(name, code) {
      let locationInfo = this.locationData[code];

      let districtInfo = new CityInfo();
      districtInfo.name = name;
      districtInfo.code = code;
      districtInfo.extent = locationInfo.extent;
      districtInfo.level=locationInfo.level;
      districtInfo.centerX=locationInfo.centerX;
      districtInfo.centerY=locationInfo.centerY;


      this.curCity = name;

      this.$emit(
        UCDistictEvent.UCDistrictCity_event_cityClickHandler,
        districtInfo
      );
    },

    init() {
      // let self = this;
      
      this.province=UCDistrictData.province;
      
      // 初始化行政区数据
      this.hotCityData = UCDistrictData.hotCityData;

      this.xzqData = UCDistrictData.xzqData;

      this.locationData = UCDistrictData.locationData;
    }
  },
  mounted() {
    let self = this;
    self.init();
  }
};
</script>


<style lang="scss"  scoped>
.city-box {
  width: 380px;
  background: #fff;
  position: absolute;
  top: 38px;
  right: 0px;
  cursor: auto;
  font-size: 12px;
  font-family: microsoft yahei, arial, tahoma, helvetica, sans-serif;
  box-shadow: 4px 6px 4px rgba(20, 50, 66, 0.4);
  border-radius: 5px;
  /*border: 1px solid rgba(20, 50, 66, 0.5);*/
}

.city-box-hidden {
  display: none;
}

.city-box-inner {
  padding: 10px;
}

.city_close {
  float: right;
  width: 14px;
  height: 14px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  background-position: -426px -28px;
}

.def_city_con {
  border-bottom: 1px solid #b5b5b5;
  padding-bottom: 10px;
}

.hot_city {
  margin-top: 10px;
  border-bottom: 1px solid #b5b5b5;
  padding-bottom: 10px;
  line-height: 22px;
}

.ps_container {
  overflow-y: auto;
  box-sizing: border-box;
  position: relative;
  z-index: 2;
  background: #fff;
  margin: 0 auto;
  height: 360px;
  width: auto;
}
.city_list_province {
  width: 100%;
}
.city_list_province_line {
  display: block;
  clear: both;
}
.clearfix:after,
.clearfix:before {
  clear: both;
  display: table;
  content: "";
}

.city_list_province_header {
  margin-top: 5px;
  width: 48px;
  float: left;
  display: block;
  line-height: 22px;
  padding-left: 15px;
}
.city_list_provin {
  cursor: pointer;
  padding-left: 9px;
  color: #666;
  font-weight: 700;
}
.city_list_province_right {
  height: auto;
  line-height: 22px;
  margin-top: 5px;
  margin-left: 60px;
  margin-right: 5px;
}

.city_list_province_right a,
.hot_city a {
  cursor: pointer;
  color: #666;
  text-decoration: none;
  margin-right: 6px;
  display: inline-block;
  line-height: 16px !important;
}
.hot_city a {
  font-weight: 700;
}
::-webkit-scrollbar {
  width: 6px;
  height: 20px;
  background-color: #eee;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 2px #eee; */
  border-radius: 3px;
  background-color: #eee;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  /* -webkit-box-shadow: inset 0 0 6px #ddd; */
  background-color: #ddd;
}
</style>

